import { RadioOptionType, RadioTagGroup } from "@/components/Radio/RadioTag";
import { chakra, FlexProps } from "@chakra-ui/react";
import { langStore, translate } from "@noli/business";
import { observer } from "mobx-react-lite";
import React, { useMemo } from "react";
import { genBlock } from "@/utils/bem";
import { AI_PARAMS_TYPES } from "@/modules/editor/constant";
import classNames from "classnames";
import { AIParamsType } from "@/modules/editor/stores/aiParams";
import { AI_Params_Words } from "@/utils/lang";

const block = genBlock("c-params-type-switch");
const IParamsTypeSwitch: React.FC<{
  direction?: FlexProps["flexDirection"];
  className?: string;
  value?: AIParamsType;
  onChange?: (value: AIParamsType) => void;
  disabled?: boolean;
}> = ({ direction = "row", className, value, onChange, disabled = true }) => {
  const lang = langStore.tgt;

  const options = useMemo(() => {
    return AI_PARAMS_TYPES.map((type) => {
      const option: RadioOptionType = {
        value: type,
        label: <>{translate(`creator-${type}-task`, lang)}</>,
      };
      return option;
    });
  }, [lang]);
  return (
    <RadioTagGroup
      options={options}
      title={`${translate(AI_Params_Words["type-title"], lang)}：`}
      className={classNames(className, block())}
      flexDirection={direction}
      useRadioGroupProps={{
        value: value,
        onChange: onChange,
      }}
      disabled={disabled}
    />
  );
};

export const ParamsTypeSwitch = chakra(observer(IParamsTypeSwitch));
